import React, {useEffect, useState, useRef} from "react";
import {useParams} from "react-router-dom";
import axiApi from "ApiCaller";
import NavBreadcrum from "components/NavBreadcrum";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import navs from "../../navs";
import {useTranslation} from "react-i18next";
import moment from "moment";
import PluginWarning from "./PluginWarning";
import Spinner from "components/loaders/spinner";

const PluginEdit = () => {
    const {token} = useParams();
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tr} = useTranslation("routes");
    const [loading, setLoading] = useState(true);
    const [importData, setImportData] = useState(null);
    const [warningsShow, setWarningsShow] = useState([]);
    const [verifiedStatus, setVerifiedStatus] = useState(false);
    const [importedStatus, setImportedStatus] = useState(false);
    const [warningsCount, setWarningsCount] = useState(0);
    const [pluginToken, setPluginToken] = useState("");

    const resultData = useRef({
        // devices
        news: {
            actives: 0,
            devices: 0,
        },
        // containers
        updated: {
            actives: 0,
            devices: 0,
        },
        // counter
        counter: {
            actives: 0,
            devices: 0,
        },
        error: "",
        warnings: 0,
        routes: {
            news: 0,
            multi: 0,
        },
        islands: 0,
        groups: 0,
    });

    const bread = [
        {name: _Tr("labels.administration"), url: "/administration", current: false},
        {
            name: _Tr("labels.plugins"),
            url: `/administration/plugins/`,
            current: false,
        },
        {
            name: _Tr("labels.plugin"),
            url: `/administration/plugins/list/${pluginToken}/`,
            current: false,
        },
        {name: _Tr("labels.import"), current: true},
    ];

    useEffect(() => {
        if (token) {
            setLoading(true);
            axiApi
                .get(`/api/plugins/inventory/imports/details/${token}/`)
                .then((resp) => {
                    if (resp.data && resp.data.status) {
                        setPluginToken(resp.data.import.plugin_token);
                        const importDetails = resp.data.import;
                        setImportData(importDetails);

                        if (importDetails.result) {
                            resultData.current = importDetails.result;
                            setWarningsCount(importDetails.result.warnings || 0);
                        }

                        if (importDetails.warnings && importDetails.warnings.messages) {
                            setWarningsShow(importDetails.warnings.messages);
                        }

                        setVerifiedStatus(importDetails.verified || false);
                        setImportedStatus(importDetails.imported || false);
                    }
                })
                .catch((err) => {
                    console.error("Error al obtener detalles de importación:", err);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [token]);

    if (loading) {
        return <Spinner />;
    }

    if (!importData) {
        return (
            <>
                <NavBreadcrum navs={navs} bread={bread} />
                <div className="alert alert-warning">
                    No se encontró información para la importación solicitada.
                </div>
            </>
        );
    }

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <div className="col-12 preview-canvas offcanvas-header mt-1">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="plug" />
                </div>

                <div className="preview-title ps-4">
                    <h5>Plugin</h5>
                </div>
            </div>
            <div className="row">
                <div className="col-md-10 col-12 m-auto">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row mt-4">
                                {/* Nueva columna con estado de verificación e importación */}
                                <div className="col-md-4 text-center">
                                    <h4>Estado</h4>
                                    <FontAwesomeIcon
                                        icon="clipboard"
                                        className="fa-2x mt-2"
                                    />
                                    <div className="col-12 d-flex justify-content-center mt-4 ">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="text-end border-0">
                                                        <h5>Verificado:</h5>
                                                    </td>
                                                    <td className="text-end border-0 ps-3">
                                                        <h5>
                                                            {verifiedStatus ? (
                                                                <FontAwesomeIcon
                                                                    icon="check"
                                                                    className="text-success"
                                                                />
                                                            ) : (
                                                                <FontAwesomeIcon
                                                                    icon="times"
                                                                    className="text-danger"
                                                                />
                                                            )}
                                                        </h5>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-end border-0">
                                                        <h5>Importado:</h5>
                                                    </td>
                                                    <td className="text-end border-0 ps-3">
                                                        <h5>
                                                            {importedStatus ? (
                                                                <FontAwesomeIcon
                                                                    icon="check"
                                                                    className="text-success"
                                                                />
                                                            ) : (
                                                                <FontAwesomeIcon
                                                                    icon="times"
                                                                    className="text-danger"
                                                                />
                                                            )}
                                                        </h5>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-end border-0">
                                                        <h5>
                                                            {_Tf("common.warnings")}:
                                                        </h5>
                                                    </td>
                                                    <td className="text-end border-0 ps-3">
                                                        <h5>{warningsCount}</h5>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="col-md-4 text-center">
                                    <h4>{_Tf("labels.news")}</h4>
                                    <FontAwesomeIcon
                                        icon="square-check"
                                        className="fa-2x mt-2"
                                    />
                                    <div className="col-12 d-flex justify-content-center mt-4">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="text-end border-0">
                                                        <h5>Dispositivos:</h5>
                                                    </td>
                                                    <td className="text-end border-0 ps-3">
                                                        <h5>
                                                            {resultData.current.news
                                                                .devices || 0}
                                                        </h5>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-end border-0">
                                                        <h5>Contenedores:</h5>
                                                    </td>
                                                    <td className="text-end border-0 ps-3">
                                                        <h5>
                                                            {resultData.current.news
                                                                .actives || 0}
                                                        </h5>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-end border-0">
                                                        <h5>Rutas:</h5>
                                                    </td>
                                                    <td className="text-end border-0 ps-3">
                                                        <h5>
                                                            {resultData.current.routes
                                                                .news || 0}
                                                        </h5>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-end border-0">
                                                        <h5>Islas:</h5>
                                                    </td>
                                                    <td className="text-end border-0 ps-3">
                                                        <h5>
                                                            {resultData.current
                                                                .islands || 0}
                                                        </h5>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-end border-0">
                                                        <h5>Grupos:</h5>
                                                    </td>
                                                    <td className="text-end border-0 ps-3">
                                                        <h5>
                                                            {resultData.current
                                                                .groups || 0}
                                                        </h5>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-md-4 text-center">
                                    <h4>{_Tf("labels.updated")}</h4>
                                    <FontAwesomeIcon
                                        icon="edit"
                                        className="fa-2x mt-2"
                                    />
                                    <div className="col-12 d-flex justify-content-center mt-4">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="text-end border-0">
                                                        <h5>Dispositivos:</h5>
                                                    </td>
                                                    <td className="text-end border-0 ps-3">
                                                        <h5>
                                                            {resultData.current.updated
                                                                .devices || 0}
                                                        </h5>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-end border-0">
                                                        <h5>Contenedores:</h5>
                                                    </td>
                                                    <td className="text-end border-0 ps-3">
                                                        <h5>
                                                            {resultData.current.updated
                                                                .actives || 0}
                                                        </h5>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {resultData.current.error && (
                            <div className="col-md-12 mt-5">
                                <div className="alert alert-danger">
                                    {resultData.current.error}
                                </div>
                            </div>
                        )}

                        <div className="col-md-12">
                            {warningsShow.length > 0 ? (
                                <PluginWarning items={warningsShow} />
                            ) : (
                                <div className="alert alert-info text-center">
                                    No {_Tf("common.warnings")}
                                </div>
                            )}
                        </div>

                        <div className="col-md-12 mt-3 text-center">
                            <p>
                                <small>
                                    Tamaño: {importData.size || "0 KB"} | Email:{" "}
                                    {importData.email || ""} | Fecha:{" "}
                                    {importData.ended
                                        ? moment(importData.ended).format(
                                              "DD/MM/YYYY HH:mm"
                                          )
                                        : // : ""}
                                          moment(importData.created).format(
                                              "DD/MM/YYYY HH:mm"
                                          )}
                                </small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default PluginEdit;
